import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./changeset_type.js";
//#region src/changeset_type_helper.ts
var changeset_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case "magic-copy": return "Magic Copy";
	}
}
//#endregion
export { changeset_type_helper_exports, name };

//# sourceMappingURL=changeset_type_helper.js.map